import ThreeCanvas from '../components/ThreeCanvas'
import LoadingOverlay from '../components/common/LoadingOverlay'

export default function ViewerPage() {
  return (
    <>
      <LoadingOverlay />
      <ThreeCanvas />
    </>
  )
}
